const loadPicture = (img, webp, path) => {
  return new Promise((resolve, reject) => {
    img.onload = () => resolve(img);
    img.onerror = () => reject(img);

    img.src = `${path}.jpg`;
    webp.srcset = `${path}.webp`;

    // const isImgComplete = img.complete;
    // const isWebpComplete = webp.complete;
    // console.warn('isImgComplete', isImgComplete);
    // console.warn('isWebpComplete', isWebpComplete);

    // img.src = path + ".jpg";
    // webp.srcset = path + ".webp";

    // if (isImgComplete) resolve();

    // img.addEventListener('load', (e) => {
    //   resolve();
    // });
    // img.addEventListener('error', (e) => {
    //   reject();
    // });
  });
};

export default loadPicture;
